import { useEffect } from 'react'

import styled from 'styled-components'

import { useLocation } from '@redwoodjs/router'

import { LayoutMode, useSidebarLayoutMode } from 'src/utils/layout'

import { StylePropsMobile } from '../../components/shared/StyledComponents'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import TopBar from '../../components/Topbar/Topbar'
import useDisclosure from '../../hooks/use-disclosure'

type Props = {
  children?: React.ReactNode
}

const Right = styled.div<StylePropsMobile>`
  flex: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  transition: width 200ms ease-out;
  overflow-x: hidden;
  height: 100dvh;

  @media print {
    height: auto;
  }
`
const Content = styled.div<StylePropsMobile>`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  background-color: ${({ theme }) => theme.colorWhite};
  overflow: hidden;

  ${({ $small }) =>
    !$small &&
    `
      width: calc(100% - 10px);
      margin: 10px 10px 0px 0px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    `}
`

const ContentContainer = styled.div`
  height: 100%;

  @media print {
    height: auto;
  }
`

const SidebarLayout = (props: Props) => {
  const { children } = props
  const { layoutMode } = useSidebarLayoutMode()
  const isTopbarLayout = layoutMode === LayoutMode.Topbar
  const hamburgerMenuState = useDisclosure()

  const { pathname } = useLocation()
  useEffect(() => {
    hamburgerMenuState.close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    if (layoutMode !== LayoutMode.Topbar) {
      hamburgerMenuState.close()
    }
  }, [hamburgerMenuState, layoutMode])

  return (
    <div className="bg-layout flex h-dvh max-w-screen">
      {!isTopbarLayout && <Sidebar layoutMode={layoutMode} />}
      <Right $small={isTopbarLayout}>
        {isTopbarLayout && (
          <TopBar
            onClickHamburger={hamburgerMenuState.toggle}
            hamburgerOpen={hamburgerMenuState.isOpen}
          />
        )}
        {!hamburgerMenuState.isOpen && (
          <Content $small={isTopbarLayout} className="border border-neutral-300">
            <ContentContainer>{children}</ContentContainer>
          </Content>
        )}
        {hamburgerMenuState.isOpen && <Sidebar layoutMode={layoutMode} />}
      </Right>
    </div>
  )
}

export default SidebarLayout
